import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=4d78b1bc&scoped=true&style=text-align%3A%20justify&"
import script from "./Privacy.vue?vue&type=script&lang=js&"
export * from "./Privacy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=4d78b1bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78b1bc",
  null
  
)

export default component.exports